export * from '../../state/magazine/selectors';



/** WEBPACK FOOTER **
 ** ./src/members/__shared__/selectors/magazine.js
 **/